import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block font-heading text-xl text-background-50 mb-4">
              黑料社区
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mt-3">
              网络热门爆料与深度挖掘的核心聚集平台，汇聚最新明星黑料、娱乐圈内幕、网红翻车事件及各类独家爆料内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-background-300"></i>
                <span>tips@heiliao.community</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-background-300"></i>
                <span>heiliao_official</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-background-300"></i>
                <span>@黑料社区官方</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 黑料社区 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}